<template>
  <v-overlay :value="overlay">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  name: "LoadingScreen",
  props: ["overlay"],
};
</script>
